import React from 'react';

const PhotoRealisticRenderingBanner = () =>{
    return (
        <>
        <div className='cadRealisticBanner cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/realistic-img-banner.webp"
            alt="realistic-services-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>Realistic Images</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default PhotoRealisticRenderingBanner;